import DEFAULT_API_ENDPOINTS from './apiEndpoints.json';

export const ENDPOINTS_URL = {
  dev: 'https://api.it-aws-dev.quirion.de/legacy/v1/endpoints',
  prod: 'https://api.it-aws-prod.quirion.de/legacy/v1/endpoints',
};

export { DEFAULT_API_ENDPOINTS };
